import React from 'react'
import { useQuery } from 'react-query'
import { api } from '../services/api'

async function getEnterprises() {
  const res = await api.get('/site/v2/pedido/lista-empresas')

  return res.data
}

export const useEnterprise = () => {
  const query = useQuery({
    queryKey: 'enterprises',
    queryFn: getEnterprises,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24,
  })

  return query
}
